import { Paths } from "../enums/Paths";

export const isCompanyHighlight = (route: string) => {
  return (
    route === Paths.CompanyList ||
    route === Paths.CompanyDetail ||
    route === Paths.RegisterCompany
  );
};

export const isUnitHighlight = (route: string) => {
  return route === Paths.UnitList || route === Paths.RegisterUnit;
};

export const isUserRoleHighlight = (route: string) => {
  return route === Paths.UserRole;
};

export const isUserRoleEditProfileHighlight = (route: string) => {
  return route === Paths.UserRoleEditProfile;
};

export const isUserExamHighlight = (route: string) => {
  return route === Paths.exams;
};

export const isScheduling = (route: string) => {
  return route === Paths.Scheduling;
};

export const isCareLinesHighlight = (route: string) => {
  return route === Paths.CareLineList || route === Paths.RegisterCareLine;
};

export const isOccupationalHealthHighlight = (route: string) => {
  return (
    route === Paths.OccupationalHealthList ||
    route === Paths.OccupationalHealthRegister
  );
};
export const isCriarAgendaHighlight = (route: string) => {
  return (
    route === Paths.AgendaList ||
    route === Paths.AgendaDias ||
    route === Paths.Agendas ||
    route === Paths.AgendasMes ||
    route === Paths.CriarAgenda
  );
};

export const isFileImport = (route: string) => {
  return route === Paths.FileImport || route === Paths.FileImport;
};

export const isCollaboratorInitial = (route: string) => {
  return route === Paths.CollaboratorInitial;
};

export const isRelationshipGhe = (route: string) => {
  return route === Paths.RelationshipGHE || route === Paths.RelationshipGHE;
};

export const isMyPeriodicsHighlight = (route: string) => {
  return route === Paths.MeusPeriodicos;
}

export const isMyCareLines = (route: string) => {
  return route === Paths.MinhaLinhaCuidado;
}

export const isAppointmentPanelHighlight = (route: string) => {
  return route === Paths.PainelAtendimento;
}

export const isPainelConsultaHighlight = (route: string) => {
  return route === Paths.PainelConsulta
    || route === Paths.AtribuirLinhaCuidado
    || route === Paths.DetalharLinhaCuidado
    || route === Paths.Prontuario 
    || route === Paths.RegistroAtendimento
    || route === Paths.HMVQuestionnaire
    || route === Paths.OMSQuestionnaire
    || route === Paths.RegistrarExame 
    || route === Paths.RegistrarAlergia;
}

export const isProntuarioHighlight = (route: string) => {
  return route === Paths.ProntuarioPaciente;
}

export const isMeusPacientesHighlight = (route: string) => {
  return route === Paths.MeusPacientes;
}

export const isPainelNavegacaoHighlight = (route: string) => {
  return route === Paths.PainelNavegacao || route.startsWith('/acompanhamentoNavegacao');
}

export const isCentralAgendamentoHighlight = (route: string) => {
  return route === Paths.CentralAgendamento;
}

export const isVitalSignHighlight = (route: string) => {
  return route === Paths.VitalSignList || route === Paths.VitalSignRegister;
}

export const getCallbackPath = (path: string) => {
  switch (path) {
    case Paths.OccupationalHealthRegister:
    case Paths.OccupationalHealthList:
      return Paths.OccupationalHealthList;
    case Paths.CareLineList:
    case Paths.RegisterCareLine:
      return Paths.CareLineList;
    case Paths.CompanyDetail:
    case Paths.CompanyList:
    case Paths.RegisterCompany:
      return Paths.CompanyList
    case Paths.UnitList:
    case Paths.RegisterUnit:
      return Paths.UnitList
    default:
      return ''
  }
}

export const isReaplicacaoHighlight = (route: string) => {
  return route === Paths.ReaplicacaoQuestionario;
}

